<template>
<div class="w-100">
    <div class="search-header">
        <div class="listing__main align-items-center">
            <div class="ads-map-view__bar">
                <div class="ads-map-view__bar-container container">
                    <Loader class="my-auto" v-if="isLoading" />
                    <div class="ads-map-view__bar-search ads-search search-header">
                        <SelectArea
                            class="ads-search__main"
                            @input="onChangeArea"
                            :is-rent-selected="true"
                        />
                        <div class="ads-search__options">
                            <v-select
                                :options="radiusOptions"
                                v-model="filters.radius"
                                @input="search(false)"
                                :reduce="radius => radius.value"
                                :searchable="false"
                                :clearable="false"
                            />
                            <ArrowDownIcon class="ads-search__options-arrow" />
                        </div>
                    </div>

                    <div class="ads-map-view__bar-item-wrapper price-range">
                        Price ({{ filters.rent_type === 'month' ? 'pcm' : 'pw' }}):
                        <div class="input-prepend" data-text="£">
                            <input
                                id="rent_cost_min"
                                type="text"
                                class="form-control"
                                :value="formattedRentCostMin"
                                @input="event => onInputRentCostMin(event, true)"
                            />
                        </div>
                        to
                        <div class="input-prepend" data-text="£">
                            <input
                                id="rent_cost_max"
                                type="text"
                                class="form-control"
                                :value="formattedRentCostMax"
                                @input="event => onInputRentCostMax(event, true)"
                            />
                        </div>
                    </div>

                    <div class="ads-map-view__bar-item-wrapper min-max-beds">
                        <select
                            class="ads-map-view__bar-select"
                            v-model="filters.number_of_rooms_min"
                            @change="search"
                        >
                            <option value="">Min beds</option>
                            <option
                                v-for="label in storeFilters.numberOfRooms"
                                :key="`number-of-rooms-min-${label}`"
                                :value="label"
                            >
                                {{ label }} {{ label === "1" ? 'bed' : 'beds' }}
                            </option>
                        </select>
                        to
                        <select
                            class="ads-map-view__bar-select"
                            v-model="filters.number_of_rooms_max"
                            @change="search"
                        >
                            <option value="">Max beds</option>
                            <option
                                v-for="label in storeFilters.numberOfRooms"
                                :key="`number-of-rooms-max-${label}`"
                                :value="label"
                            >
                                {{ label }} {{ label === "1" ? 'bed' : 'beds' }}
                            </option>
                        </select>
                    </div>

                    <div class="ads-map-view__bar-item-wrapper filters-btn">
                        <button class="ads-map-view__bar-btn btn btn--empty" @click.prevent="showFilters = !showFilters">
                            <div class="d-flex align-items-baseline gap-2">
                                Filters
                                <ArrowDownIcon class="ads-map-view__bar-btn-arrow" />
                            </div>
                        </button>
                    </div>

                </div>
            </div>

        </div>
    </div>
    <div
        class="ads-map-view__filters"
        :class="{'active': showFilters}"
        v-on-clickaway="
            () => {
                showFilters = false;
            }
        ">
        <div class="ads-map-view__filters-container d-lg-flex">
            <div class="col-lg-4 px-2">
                <div class="filter-box price-range">

                    <h5 class="filter-box__title">Rent cost</h5>
                    <div class="filter-box__content">
                        <div class="form-group row">
                            <div class="col-6">
                                <div class="input-with-label">
                                    <label for="rent_cost_min">min price</label>
                                    <input
                                        id="rent_cost_min"
                                        type="text"
                                        class="form-control"
                                        :value="formattedRentCostMin"
                                        @input="event => onInputRentCostMin(event, false)"
                                    />
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="input-with-label">
                                    <label for="rent_cost_max">max price</label>
                                    <input
                                        id="rent_cost_max"
                                        type="text"
                                        class="form-control"
                                        :value="formattedRentCostMax"
                                        @input="event => onInputRentCostMax(event, false)"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="filter-box min-max-beds" v-if="storeFilters.numberOfRooms">
                    <h5 class="filter-box__title">No. of beds</h5>
                    <div class="filter-box__content">
                        <div class="form-group">
                            <div class="row">
                                <div class="col-6">
                                    <select
                                        class="form-control"
                                        v-model="filters.number_of_rooms_min"
                                        @change="fetchVirtualResults(filters)"
                                    >
                                        <option value="">No min.</option>
                                        <option
                                            v-for="label in storeFilters.numberOfRooms"
                                            :key="`number-of-rooms-min-${label}`"
                                            :value="label"
                                        >
                                            {{ label }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-6">
                                    <select
                                        class="form-control"
                                        v-model="filters.number_of_rooms_max"
                                        @change="fetchVirtualResults(filters)"
                                    >
                                        <option value="">No max.</option>
                                        <option
                                            v-for="label in storeFilters.numberOfRooms"
                                            :key="`number-of-rooms-max-${label}`"
                                            :value="label"
                                        >
                                            {{ label }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="filter-box" >
                    <h5 class="filter-box__title">Price</h5>
                    <div class="filter-box__content">
                        <div class="row" v-if="storeFilters.rentTypes">
                            <div class="col-6"
                                v-for="(label, slug) in storeFilters.rentTypes"
                                :key="`rent-type-${slug}`"
                            >
                                <label>
                                    <input
                                        type="radio"
                                        v-model="filters.rent_type"
                                        :value="slug"
                                        @change="fetchVirtualResults(filters);"
                                    >
                                    <span>{{ label }}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="filter-box">
                    <h5 class="filter-box__title">Property type</h5>
                    <div class="filter-box__content">
                        <label v-for="(label, slug) in storeFilters.propertyTypes" :key="`property-type-${slug}`">
                            <input
                                type="checkbox"
                                v-model="filters.property_type"
                                :value="slug"
                                @change="fetchVirtualResults(filters)"
                            >
                            <span>{{ label }}</span>
                        </label>
                    </div>
                </div>

                <div class="filter-box">
                    <div class="filter-box__content">
                        <label>
                            <input
                                type="checkbox"
                                v-model="filters.include_let_agreed"
                                @change="fetchVirtualResults(filters)"
                            >
                            <span>Include Let Agreed</span>
                        </label>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 px-2">
                <div class="filter-box" v-if="storeFilters.numberOfTotalBathrooms">
                    <h5 class="filter-box__title">No. of min. baths</h5>
                    <div class="filter-box__content">
                        <div class="form-group">
                            <select
                                class="form-control"
                                v-model="filters.number_of_total_bathrooms"
                                @change="fetchVirtualResults(filters)"
                            >
                                <option value="">No preferences</option>
                                <option
                                    v-for="label in storeFilters.numberOfTotalBathrooms"
                                    :key="`number-of-bathrooms-${label}`"
                                    :value="label"
                                >
                                    {{ label }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="filter-box">
                    <h5 class="filter-box__title">Available from</h5>
                    <div class="filter-box__content">
                        <div class="form-group">
                            <label>
                                <input
                                    type="radio"
                                    v-model="filters.to_move_in"
                                    value="anytime"
                                    @change="setNullDateRangeValue(); fetchVirtualResults(filters)()"
                                >
                                <span>Anytime</span>
                            </label>
                            <label>
                                <input
                                    type="radio"
                                    v-model="filters.to_move_in"
                                    value="between"
                                    @change="setNullDateRangeValue"
                                >
                                <span>Between</span>
                            </label>
                            <DateRangePicker
                                v-show="filters.to_move_in === 'between'"
                                v-model="filters.to_move_in_range"
                                @input="fetchVirtualResults(filters)"
                            />
                        </div>
                    </div>
                </div>

                <div class="filter-box" v-if="storeFilters.accommodationPeriod">
                    <h5 class="filter-box__title">Accommodation period</h5>
                    <div class="filter-box__content">
                        <div class="form-group input-group">
                            <select
                                class="form-control"
                                v-model="filters.accommodation_period_min"
                                @change="fetchVirtualResults(filters)"
                            >
                                <option value="">No min</option>
                                <option
                                    v-for="(value, key) in accommodationPeriodMinList"
                                    :key="`accommodation-period-min-${key}`"
                                    :value="key"
                                >
                                    {{ value }}
                                </option>
                            </select>
                            <select
                                class="form-control"
                                v-model="filters.accommodation_period_max"
                                @change="fetchVirtualResults(filters)"
                            >
                                <option value="">No max</option>
                                <option
                                    v-for="(value, key) in accommodationPeriodMaxList"
                                    :key="`accommodation-period-max-${key}`"
                                    :value="key"
                                >
                                    {{ value }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="filter-box" v-if="storeFilters.occupation && storeFilters.gender">
                    <h5 class="filter-box__title">Occupation / Gender</h5>
                    <div class="filter-box__content">
                        <div class="form-group">
                            <label>
                                <input
                                    type="radio"
                                    v-model="filters.occupation"
                                    value=""
                                    @change="fetchVirtualResults(filters)"
                                >
                                <span>Any occupation</span>
                            </label>
                            <label
                                v-for="(label, slug) in storeFilters.occupation"
                                :key="`occupation-${slug}`"
                            >
                                <input
                                    type="radio"
                                    v-model="filters.occupation"
                                    :value="slug"
                                    @change="fetchVirtualResults(filters)"
                                >
                                <span>{{ label }}</span>
                            </label>
                        </div>
                        <div class="form-group">
                            <label>
                                <input
                                    type="radio"
                                    v-model="filters.gender"
                                    value=""
                                    @change="fetchVirtualResults(filters)"
                                >
                                <span>Any gender</span>
                            </label>
                            <label
                                v-for="(label, slug) in storeFilters.gender"
                                :key="`gender-${slug}`"
                            >
                                <input
                                    type="radio"
                                    v-model="filters.gender"
                                    :value="slug"
                                    @change="fetchVirtualResults(filters)"
                                >
                                <span>{{ label }}</span>
                            </label>
                        </div>
                    </div>
                </div>

                <div class="filter-box">
                    <h5 class="filter-box__title">Must haves</h5>
                    <div class="filter-box__content">
                        <label
                            v-for="(label, slug) in storeFilters.amenities"
                            :key="`must-have-${slug}`"
                        >
                            <input
                                type="checkbox"
                                v-model="filters.amenities"
                                :value="slug"
                                @change="fetchVirtualResults(filters)"
                            >
                            <span>{{ label }}</span>
                        </label>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 px-2">
                <div class="filter-box" v-if="storeFilters.publishedBy">
                    <h5 class="filter-box__title">Published by</h5>
                    <div class="filter-box__content">
                        <div class="form-group">
                            <select
                                class="form-control"
                                v-model="filters.published_by"
                                @change="fetchVirtualResults(filters)"
                            >
                                <option value="">No preferences</option>
                                <option
                                    v-for="(label, key) in storeFilters.publishedBy"
                                    :key="`published-by-${key}`"
                                    :value="key"
                                >
                                    {{ label }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="filter-box" v-if="storeFilters.ageRange">
                    <h5 class="filter-box__title">Age between</h5>
                    <div class="filter-box__content">
                        <div class="form-group">
                            <select
                                class="form-control"
                                v-model="filters.allow_age_range"
                                @change="fetchVirtualResults(filters)"
                            >
                                <option value="">Any</option>
                                <option
                                    v-for="(label, slug) in storeFilters.ageRange"
                                    :key="`age-range-${slug}`"
                                    :value="slug"
                                >
                                    {{ label }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="filter-box">
                    <h5 class="filter-box__title">Preferences</h5>
                    <div class="filter-box__content">
                        <div class="form-group">
                            <label v-if="storeFilters.referencesRequired">
                                <input
                                    type="checkbox"
                                    v-model="filters.references_required"
                                    value="1"
                                    @change="fetchVirtualResults(filters)"
                                >
                                <span>References required</span>
                            </label>
                            <label>
                                <input
                                    type="checkbox"
                                    v-model="filters.furnished"
                                    value="1"
                                    @change="fetchVirtualResults(filters)"
                                >
                                <span>Furnished</span>
                            </label>
                            <label>
                                <input
                                    type="checkbox"
                                    v-model="filters.bills_included"
                                    value="1"
                                    @change="fetchVirtualResults(filters)"
                                >
                                <span>Bills included</span>
                            </label>
                            <label>
                                <input
                                    type="checkbox"
                                    v-model="filters.pets_considered"
                                    value="1"
                                    @change="fetchVirtualResults(filters)"
                                >
                                <span>Pets considered</span>
                            </label>
                            <label v-if="storeFilters.allowShortTermStay">
                                <input
                                    type="checkbox"
                                    v-model="filters.allow_short_term_stay"
                                    value="1"
                                    @change="fetchVirtualResults(filters)"
                                >
                                <span>Allow short term stay</span>
                            </label>
                        </div>
                    </div>
                </div>

                <div class="filter-box pb-4 pb-lg-0">
                    <h5 class="filter-box__title">More Preferences</h5>
                    <div class="filter-box__content">
                        <div class="form-group">
                            <label>
                                <input
                                    type="radio"
                                    v-model="filters.required_preferences"
                                    value=""
                                    @change="fetchVirtualResults(filters)"
                                >
                                <span>No preference</span>
                            </label>
                            <label
                                v-for="(label, slug) in storeFilters.requiredPreferences"
                                :key="`required-preferences-${slug}`"
                            >
                                <input
                                    type="radio"
                                    v-model="filters.required_preferences"
                                    :value="slug"
                                    @change="fetchVirtualResults(filters)"
                                >
                                <span>{{ label }}</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="ads-map-view__filters-actions w-lg-fit mx-auto">
            <button
                type="button"
                class="btn btn--primary btn--sm js-show-results-btn"
                :disabled="!virtualResults"
                @click="search"
            >
                {{ virtualResults }} results
            </button>
            <button
                type="button"
                class="btn btn--dark-empty btn--sm"
                @click="resetSearch"
            >
                Clear
            </button>
        </div>
    </div>
    <section class="section container listing">
        <div class="listing__main">
            <div class="listing__results">
                <div class="my-3 listing__results-category" v-if="categoryText.length > 0">
                    <div class="over-desktop-only">
                        <div v-if="categoryText.length < 60 || categoryTextExpanded">
                            {{ categoryText }}
                        </div>
                        <div v-else-if="categoryText.length >= 60">
                            {{ categoryText.substring(0, 60) + '...' }}
                        </div>
                        <div class="see-more-btn" v-if="categoryText.length >= 60">
                            <button class="primary-color-text" @click.prevent="categoryTextExpanded = true" v-if="!categoryTextExpanded">
                                Show more
                            </button>
                            <button class="primary-color-text" @click.prevent="categoryTextExpanded = false" v-else>
                                Show less
                            </button>
                        </div>
                    </div>
                    <!-- Hidden on request, enable after fixing -->
                    <!-- <div class="less-desktop-only">
                        <div v-if="categoryTextExpanded">
                            {{ categoryText }}
                        </div>
                        <div v-else>
                            {{ categoryText.split(':')[0] + ': ...' }}
                        </div>
                        <div class="see-more-btn">
                            <button class="primary-color-text" @click.prevent="categoryTextExpanded = true" v-if="!categoryTextExpanded">
                                Show more
                            </button>
                            <button class="primary-color-text" @click.prevent="categoryTextExpanded = false" v-else>
                                Show less
                            </button>
                        </div>
                    </div> -->
                </div>

                <div class="listing__results-header px-3 flex-lg-wrap pb-3">
                    <div class="input-group over-desktop-only" v-if="!pagination.recordsFiltered">
                        <div class="form-group mb-0">
                            <button
                                v-if="!isEmptyArea"
                                type="button"
                                class="btn btn--dark-empty btn--sm"
                                @click="onGetAlerts"
                            >
                                Get Alerts
                            </button>
                        </div>
                    </div>
                    <a
                        href="#"
                        class="btn btn--sm btn--primary toggle-mobile-filters"
                        @click.prevent="showFilters = true"
                    >
                        Filter {{ virtualResults }} results
                    </a>

                    <div class="form-group mb-0 toggle-mobile-filters">
                        <button
                            v-if="!isEmptyArea"
                            type="button"
                            class="btn btn--dark-empty btn--sm"
                            @click="onGetAlerts"
                        >
                            Get Alerts
                        </button>
                    </div>

                    <div class="input-group pt-1 pe-1" v-if="pagination.recordsFiltered">
                        <div class="form-group mb-0">
                            <label class="over-desktop-only">Sort by</label>
                            <select
                                class="form-control"
                                v-model="filters.sort_by"
                                @change="search(false)"
                            >
                                <option
                                    v-for="(label, slug) in storeFilters.sortBy"
                                    :key="`sort-by-${slug}`"
                                    :value="slug"
                                >
                                    {{ label }}
                                </option>
                            </select>
                        </div>
                        <p class="mb-0 over-desktop-only">
                            <strong>{{ paginationInfoText }}</strong>
                        </p>
                        <div class="form-group mb-0 over-desktop-only">
                            <button
                                v-if="!isEmptyArea"
                                type="button"
                                class="btn btn--dark-empty btn--sm"
                                @click="onGetAlerts"
                            >
                                Get Alerts
                            </button>
                        </div>
                        <div class="ms-auto over-desktop-only d-flex align-items-center">
                            <button
                                type="button"
                                class="btn btn--sm btn--secondary-v2-empty listing-toggle-map"
                                @click.prevent="goToMapView()"
                            >
                                <svg style="width: 25px;" width="49" height="37" viewBox="0 0 49 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M32.4604 10.5558C32.4604 12.9816 31.1613 16.9168 29.1462 21.0329C27.6313 24.1273 25.8264 27.0938 24.1598 29.2952C22.4656 27.0116 20.6396 24.0156 19.1161 20.9283C17.0997 16.8422 15.8047 12.9765 15.8047 10.5558C15.8047 5.78917 19.5741 2 24.1326 2C28.691 2 32.4604 5.78917 32.4604 10.5558Z" stroke="#4C1B7A" stroke-width="4"/>
                                    <path d="M2 34.6719H47" stroke="#4C1B7A" stroke-width="4" stroke-linecap="round"/>
                                    <line x1="7.74831" y1="24.9713" x2="2.74831" y2="33.9713" stroke="#4C1B7A" stroke-width="4"/>
                                    <line x1="6" y1="26" x2="18" y2="26" stroke="#4C1B7A" stroke-width="4"/>
                                    <line x1="30" y1="26" x2="42" y2="26" stroke="#4C1B7A" stroke-width="4"/>
                                    <line x1="46.3359" y1="34.1094" x2="40.3359" y2="25.1094" stroke="#4C1B7A" stroke-width="4"/>
                                </svg>

                                <span v-text="'Map'"></span>

                            </button>
                        </div>
                        <div class="form-group mb-0 results-per-page">
                            <label class="ms-auto over-desktop-only">Items per page</label>
                            <select
                                class="form-control"
                                v-model="filters.length"
                                @change="search"
                            >
                                <option
                                    v-for="label in storeFilters.itemsPerPage"
                                    :key="`items-per-page-${label}`"
                                    :value="label"
                                >
                                    {{ label }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>

                <button
                    type="button"
                    class="btn btn--sm btn--secondary-v2-empty listing-toggle-map ms-auto less-desktop-only"
                    @click.prevent="goToMapView()"
                >

                    <svg style="width: 25px;" width="49" height="37" viewBox="0 0 49 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M32.4604 10.5558C32.4604 12.9816 31.1613 16.9168 29.1462 21.0329C27.6313 24.1273 25.8264 27.0938 24.1598 29.2952C22.4656 27.0116 20.6396 24.0156 19.1161 20.9283C17.0997 16.8422 15.8047 12.9765 15.8047 10.5558C15.8047 5.78917 19.5741 2 24.1326 2C28.691 2 32.4604 5.78917 32.4604 10.5558Z" stroke="#4C1B7A" stroke-width="4"/>
                        <path d="M2 34.6719H47" stroke="#4C1B7A" stroke-width="4" stroke-linecap="round"/>
                        <line x1="7.74831" y1="24.9713" x2="2.74831" y2="33.9713" stroke="#4C1B7A" stroke-width="4"/>
                        <line x1="6" y1="26" x2="18" y2="26" stroke="#4C1B7A" stroke-width="4"/>
                        <line x1="30" y1="26" x2="42" y2="26" stroke="#4C1B7A" stroke-width="4"/>
                        <line x1="46.3359" y1="34.1094" x2="40.3359" y2="25.1094" stroke="#4C1B7A" stroke-width="4"/>
                    </svg>

                    <span v-text="'Map'"></span>

                </button>

                <template v-if="isLoading">
                    <AdCardSkeleton
                        v-for="i in arrayGenerator(parseInt(filters.length, 10))"
                        :key="`advert-card-skeleton-${i}`"
                    />
                </template>

                <div class="listing__results-list" v-else>
                    <FeaturedAds v-if="featuredAds.length === 2" class="list-item gap-2 p-4" :ads="featuredAds" :rent-type="filters.rent_type" />
                    <div class="featured-posts-wrapper">
                        <AdCard
                            v-for="ad in featuredAds"
                            :ad="ad"
                            :key="ad.slug"
                            :rent-type="filters.rent_type"
                            :has-posted-by="!!ad.company_image_url"
                            :is-main-search-card="true"
                            :is-featured="true"
                        />
                    </div>
                    <AdCard
                        v-for="ad in ads"
                        :ad="ad"
                        :key="ad.slug"
                        :rent-type="filters.rent_type"
                        :has-posted-by="!!ad.company_image_url"
                        :is-main-search-card="true"
                        :with-double-gallery="true"
                    />
                </div>

                <BPagination
                    v-if="pagination.recordsFiltered > filters.length"
                    :value="pagination.currentPage"
                    :total-rows="pagination.recordsFiltered"
                    :per-page="pagination.length"
                    :limit="pagination.limitButtons"
                    @page-click="onChangePage"
                />

            </div>
        </div>

        <UserAlertsModal
            v-if="!isEmptyArea"
            :show-modal="showUserAlertsModal"
            :filters="filters"
            :area="area"
            @close="showUserAlertsModal = false"
        />
    </section>
</div>
</template>

<script>
import {
    arrayGenerator,
    filterFieldDependency,
    getDefaultDateRangeValue, getNullDateRangeValue,
} from '@helpers/helpers';
import {
    getUrlSegment,
    redirectTo,
    replaceSearchUrl,
    urlParamsToJson,
} from '@helpers/url-handler';
import { BPagination } from 'bootstrap-vue';
import { debounce } from 'lodash';
import { directive as onClickaway } from 'vue-clickaway2';
import vSelect from 'vue-select';
import { mapActions, mapMutations, mapState } from 'vuex';

const AdCard = () => import('@components/AdCard/AdCard.vue');
const AdCardSkeleton = () => import('@components/AdCard/AdCardSkeleton.vue');
const DateRangePicker = () => import('@components/partials/date/DateRangePicker.vue');
const SelectArea = () => import('@components/partials/select/SelectArea.vue');
const UserAlertsModal = () => import('@components/UserAdAlerts/partials/UserAlertsModal.vue');
const ArrowDownIcon = () => import('@components/partials/icons/ArrowDownIcon.vue');
const Loader = () => import('../partials/icons/Loader.vue');
const FeaturedAds = () => import('@components/Search/partials/FeaturedAds.vue');

export default {
    directives: {
        onClickaway,
    },
    components: {
        AdCard,
        AdCardSkeleton,
        BPagination,
        DateRangePicker,
        SelectArea,
        UserAlertsModal,
        vSelect,
        ArrowDownIcon,
        Loader,
        FeaturedAds,
    },
    props: {
        categoryText: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            error: null,
            filters: null,
            showFilters: false,
            isLoading: false,
            selectedArea: {},
            showUserAlertsModal: false,
            numberOfRooms: null,
            numberOfTotalBathrooms: null,
            categoryTextExpanded: false,
        };
    },
    created() {
        this.setFilters();
    },
    computed: {
        ...mapState('ads', [
            'ads',
            'pagination',
            'virtualResults',
            'searchHeading1',
            'adCategory',
            'storeFilters',
            'defaults',
            'featuredAds',
        ]),
        ...mapState('area', [
            'area',
        ]),
        ...mapState([
            'app',
        ]),
        ...mapState('user', ['user']),
        paginationInfoText() {
            const filtered = this.pagination.recordsFiltered;
            if (!filtered) {
                return 'No results';
            }
            const start = parseInt(this.pagination.start, 10) + 1;
            let end = parseInt(this.pagination.start, 10) + parseInt(this.pagination.length, 10);
            end = end <= this.pagination.recordsFiltered ? end : this.pagination.recordsFiltered;

            return `Showing ${start}-${end} from ${filtered} results`;
        },
        propertiesHiddenCount() {
            return this.pagination.recordsFiltered - this.ads.length;
        },
        accommodationPeriodMinList() {
            return filterFieldDependency(this.storeFilters.accommodationPeriod, this.filters.accommodation_period_max);
        },
        accommodationPeriodMaxList() {
            return filterFieldDependency(this.storeFilters.accommodationPeriod, this.filters.accommodation_period_min, true);
        },
        radiusOptions() {
            const options = Object.keys(this.storeFilters.radius).map((key) => ({
                value: key,
                label: this.storeFilters.radius[key],
            }));

            const sortedRadiusOptions = options.sort((a, b) => parseFloat(a.value) - parseFloat(b.value));

            return sortedRadiusOptions;
        },
        formattedRentCostMin() {
            return this.formatNumber(this.filters.rent_cost_min);
        },
        formattedRentCostMax() {
            return this.formatNumber(this.filters.rent_cost_max);
        },
        isEmptyArea() {
            return !(this.area && this.area.slug);
        },
    },
    mounted() {
        window.onpopstate = async () => {
            this.setFilters();
            this.slider.set([
                parseFloat(this.filters.rent_cost_min),
                parseFloat(this.filters.rent_cost_max),
            ]);
            await this.fetchArea({
                searchString: getUrlSegment(2),
                searchType: 'slug',
            });
            this.search(false);
        };
    },
    watch: {
        searchHeading1(searchHeading1) {
            document.title = `${searchHeading1} | krispyhouse`;
        },
    },
    methods: {
        ...mapActions('ads', [
            'fetchAds',
            'fetchVirtualResults',
        ]),
        ...mapMutations('area', [
            'setArea',
        ]),
        ...mapActions('area', [
            'fetchArea',
        ]),
        arrayGenerator,
        async search(resetStart = true) {
            this.isLoading = true;
            this.scrollTop();
            this.showFilters = false;

            if (resetStart) {
                this.filters.start = 0;
            }

            replaceSearchUrl(this.adCategory.is_rent, this.filters.property_type, this.area, this.filters);

            await this.fetchAds(this.filters);

            this.isLoading = false;
        },
        resetSearch() {
            this.setFilters(true);
            this.search();
        },
        formatNumber(value) {
            if (!value) return '';
            return parseFloat(value).toLocaleString();
        },
        onInputRentCostMin(event, autoSearch = false) {
            const value = event.target.value.replace(/,/g, '');
            if (!Number.isNaN(value)) {
                this.filters.rent_cost_min = value;
            }

            if (autoSearch) this.onPriceChange();
        },
        onInputRentCostMax(event, autoSearch = false) {
            const value = event.target.value.replace(/,/g, '');
            if (!Number.isNaN(value)) {
                this.filters.rent_cost_max = value;
            }

            if (autoSearch) this.onPriceChange();
        },
        onPriceChange: debounce(function () {
            this.search();
        }, 1000),
        onChangePage(bvEvent, page) {
            this.filters.start = (page - 1) * this.filters.length;
            this.search(false);
        },
        setNullDateRangeValue() {
            this.filters.to_move_in_range = getNullDateRangeValue();
        },
        setDefaultDateRange() {
            this.filters.to_move_in_range = getDefaultDateRangeValue();
        },
        scrollTop() {
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth',
            });
        },
        redirectTo,
        onChangeArea() {
            this.filters.east = '';
            this.filters.north = '';
            this.filters.west = '';
            this.filters.south = '';
            this.search();
        },
        setFilters(isDefaultData = false) {
            this.filters = urlParamsToJson({
                area: {
                    urlParamName: 'area',
                    defaultValue: '',
                },
                include_let_agreed: {
                    urlParamName: 'include_let_agreed',
                    defaultValue: this.defaults.includeLetAgreed,
                },
                rent_cost_min: {
                    urlParamName: 'rent_cost_min',
                    defaultValue: this.defaults.rentCostMinMonth,
                },
                rent_cost_max: {
                    urlParamName: 'rent_cost_max',
                    defaultValue: this.defaults.rentCostMaxMonth,
                },
                rent_type: {
                    urlParamName: 'rent_type',
                    defaultValue: 'month',
                },
                property_type: {
                    urlParamName: 'property_type',
                    defaultValue: [],
                },
                number_of_rooms_min: {
                    urlParamName: 'number_of_rooms_min',
                    defaultValue: '',
                },
                number_of_rooms_max: {
                    urlParamName: 'number_of_rooms_max',
                    defaultValue: '',
                },
                number_of_total_bathrooms: {
                    urlParamName: 'number_of_total_bathrooms',
                    defaultValue: '',
                },
                allow_short_term_stay: {
                    urlParamName: 'allow_short_term_stay',
                    defaultValue: '',
                },
                references_required: {
                    urlParamName: 'references_required',
                    defaultValue: '',
                },
                to_move_in: {
                    urlParamName: 'to_move_in',
                    defaultValue: 'anytime',
                },
                to_move_in_range: {
                    urlParamName: 'to_move_in_range',
                    defaultValue: getNullDateRangeValue(),
                },
                accommodation_period_min: {
                    urlParamName: 'accommodation_period_min',
                    defaultValue: '',
                },
                accommodation_period_max: {
                    urlParamName: 'accommodation_period_max',
                    defaultValue: '',
                },
                occupation: {
                    urlParamName: 'occupation',
                    defaultValue: '',
                },
                gender: {
                    urlParamName: 'gender',
                    defaultValue: '',
                },
                allow_age_range: {
                    urlParamName: 'allow_age_range',
                    defaultValue: '',
                },
                required_preferences: {
                    urlParamName: 'required_preferences',
                    defaultValue: '',
                },
                furnished: {
                    urlParamName: 'furnished',
                    defaultValue: '',
                },
                bills_included: {
                    urlParamName: 'bills_included',
                    defaultValue: '',
                },
                pets_considered: {
                    urlParamName: 'pets_considered',
                    defaultValue: '',
                },
                amenities: {
                    urlParamName: 'amenities',
                    defaultValue: [],
                },
                published_by: {
                    urlParamName: 'published_by',
                    defaultValue: '',
                },
                // pagination
                start: {
                    urlParamName: 'start',
                    defaultValue: 0,
                },
                length: {
                    urlParamName: 'length',
                    defaultValue: this.defaults.itemsPerPage,
                },
                // sorting
                sort_by: {
                    urlParamName: 'sort_by',
                    defaultValue: this.defaults.sortBy,
                },
                radius: {
                    urlParamName: 'radius',
                    defaultValue: this.defaults.radius,
                },
                map: {
                    urlParamName: 'map',
                    defaultValue: false,
                },
            },
            isDefaultData);
        },
        onChangeAdCategory(event) {
            if (event.target.value === 'rent') {
                redirectTo('/properties-to-rent');
            } else {
                redirectTo('/want-properties');
            }
        },
        onGetAlerts() {
            if (!this.user) {
                this.$root.$emit('open-login-modal');
                return;
            }
            this.showUserAlertsModal = true;
        },
        goToMapView() {
            const newUrl = new URL(`${window.location.href.replace(window.location.origin, `${window.location.origin}/map`)}`);
            newUrl.searchParams.set('length', 500);
            newUrl.searchParams.set('map', true);
            redirectTo(newUrl);
        },
    },
};
</script>
